import PixDetectView from './PixDetectView.vue';

export default [
  {
    path: '/app/accounts/:accountId/pix-detect',
    name: 'pix_detect_index',
    component: PixDetectView,
    meta: {
      requiresAuth: true,
      layout: 'dashboard',
      permissions: ['administrator', 'agent'],
    },
  },
];